import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  kpis: []
}

const mutations = {  
  SET_KPIS (state, payload) {
    state.kpis = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  kpiList: (context, id) => {
    return Vue.http.get(`${env.API}/api/kpi-con`)    
      .then((response) => {        
        context.commit('SET_KPIS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  kpiByIds: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&ids[]=${element}`
      }
    }
    if (Array.isArray(data.role)) {
      for (let r of data.role) {
        query += `&role[]=${r}`
      }
    }
    return Vue.http.get(`${env.API}/api/kpi-con/by-ids${query}`)    
      .then((response) => {        
        context.commit('SET_KPIS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createKPIC: (context, data) => {
    return Vue.http.post(`${env.API}/api/kpi-con`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closeKpiCon: (context, data) => {
    const { id, accomplished, planid } = data
    return Vue.http.put(`${env.API}/api/kpi-con/close/${id}`, { accomplished, planid })    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getKpiConById: (context, id) => {
    return Vue.http.get(`${env.API}/api/kpi-con/by-id/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateBKpiCon: (context, data) => {
    return Vue.http.put(`${env.API}/api/kpi-con/update/batch/kpicon`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getKpis: (state) => state.kpis
}

export const kpicon = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kpi_con.js